import {jwtDecode} from 'jwt-decode';
import {useSelector} from 'react-redux';
import {Navigate, Outlet} from 'react-router-dom';

import {selectAuth} from '../../redux/selectors';

const AdminProtectedRoute = () => {
  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const decodedToken = token ? jwtDecode(token) : {};

  const role = decodedToken?.role;

  if (!auth.loggedIn) {
    return <Navigate to={'/auth/login'} replace />;
  }

  if (role !== 'ADMIN') {
    return <Navigate to={'/'} replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;
